import { Dialog, DialogTitle } from "@material-ui/core";
import React from "react";
import "./styles.scss";

interface VideoDialogProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  title: string;
  videoId: string;
}

export const VideoDialog = (props: VideoDialogProps): JSX.Element => {
 const { open, setOpen, title, videoId } = props;
  return (
    <Dialog open={open} onClose={() => setOpen(false)} className="video-dialog">
      <DialogTitle>{title}</DialogTitle>
      <iframe
        className="video-dialog-iframe"
        title={title}
        width="560"
        height="315"
        sandbox="allow-same-origin allow-scripts allow-popups"
        src={`https://video.igem.org/videos/embed/${videoId}?title=0&warningTitle=0&peertubeLink=0`}
        frameBorder="0"
        allowFullScreen
      />
    </Dialog>
  );
};
